import {StyleSheet} from 'react-native';
import {colors} from './rulesEngine';

export const textColor = colors.text;
export const textMutedColor = colors.textMuted;
export const accentColor = colors.accent;
export const dangerColor = colors.danger;
export const hairlineColor = colors.border;
export const toggleOnColor = colors.toggleOn;
export const toggleOffColor = colors.toggleOff;

export const switchTrackColor = {false: toggleOffColor, true: toggleOnColor};
export const switchThumbColor = textColor;

export const breakpointPhone = 768;
export const breakpointDesktop = 1000;
export const touchTargetMin = 44;
export const touchRowMinHeight = 56;
export const touchButtonHeight = 48;
export const mobileInputFontSize = 16;
export const mobileBandHeadSize = 18;
export const hiddenStyle = {display: 'none'};
export const placeholderColor = textMutedColor;

export const chevronSize = 22;
export const chevronColor = textMutedColor;
export const lockIconSize = 16;
export const infoIconColor = textMutedColor;
export const infoIconStyle = {color: infoIconColor, fontSize: 16};

export const groupBg = '#0d1e30';
export const groupBorderColor = '#1a3452';
export const groupRadius = 10;
export const groupHeaderText = {
  fontFamily: 'Poppins_600SemiBold',
  fontSize: 15,
  color: textColor
};
export const groupHeaderDescText = {
  fontFamily: 'Poppins_500Medium',
  fontSize: 12,
  color: textMutedColor
};
export const groupCountPillBg = 'rgba(51, 101, 153, 0.45)';
export const groupCountPillText = {
  fontFamily: 'Poppins_700Bold',
  fontSize: 11,
  color: textColor
};
export const groupDimmedOpacity = 0.55;

export const rowBg = 'rgba(30, 45, 61, 0.5)';
export const rowRadius = 6;
export const rowMinHeight = 50;
export const rowLabelText = {
  fontFamily: 'Poppins_500Medium',
  fontSize: 14,
  color: textColor
};
export const subLabelText = {
  fontFamily: 'Poppins_600SemiBold',
  fontSize: 11,
  letterSpacing: 1.2,
  textTransform: 'uppercase',
  color: textMutedColor
};
export const lockedRowText = textMutedColor;
export const lockedRowOpacity = 0.8;
export const matchRowBorderColor = accentColor;
export const matchRowBg = 'rgba(28, 187, 119, 0.11)';

export const tooltipGradientColors = ['#8a9daf', '#d7e1e9'];
export const tooltipInkColor = '#1a2a3a';
export const tooltipText = {
  fontFamily: 'Poppins_500Medium',
  fontSize: 12,
  lineHeight: 18,
  color: tooltipInkColor
};
export const tooltipRadius = 5;
export const tooltipWidth = 260;

export const numberInputBg = '#1E2D3D';
export const numberInputRadius = 4;
export const numberInputHeight = 30;
export const numberInputText = {
  fontFamily: 'Poppins_600SemiBold',
  fontSize: 15,
  color: textColor
};
export const textInputBg = '#1E2D3D';
export const textInputRadius = 6;
export const textInputHeight = 36;
export const textInputText = {
  fontFamily: 'Poppins_500Medium',
  fontSize: 14,
  color: textColor
};

export const teamAccent = '#e67e22'; // PIRE orange, rulesEngine.js avatarColors[3]; design notes 2b4bb10
export const bandTeamBorder = 'rgba(230, 126, 34, 0.4)';
export const bandTeamGlow = 'inset 0 0 40px rgba(230, 126, 34, 0.05)';
export const bandTeamNoteBg = 'rgba(230, 126, 34, 0.08)';
export const bandTeamNoteBorder = 'rgba(230, 126, 34, 0.3)';
export const bandTeamNoteText = '#ffd3a8';
export const bandTeamRailBg = '#2b2b2e';
export const bandTeamChipBg = '#2b2b2e';
export const bandTeamChipBorder = 'rgba(230, 126, 34, 0.5)';
export const bandCustomerAccent = textMutedColor;
export const bandCustomerBorder = 'rgba(142, 172, 196, 0.35)';
export const bandCustomerRailBg = '#1f3245';
export const bandCustomerChipBg = '#1f3245';
export const bandRailWidth = 38;
export const bandRailText = {
  fontFamily: 'Poppins_700Bold',
  fontSize: 12,
  letterSpacing: 2.4,
  textTransform: 'uppercase'
};
export const bandChipText = {
  fontFamily: 'Poppins_700Bold',
  fontSize: 11,
  letterSpacing: 0.5,
  textTransform: 'uppercase'
};
export const bandChipRadius = 12;

export const groupOpenBorderColor = {
  team: 'rgba(230, 126, 34, 0.55)',
  customer: 'rgba(142, 172, 196, 0.55)'
};

const styles = StyleSheet.create({
  band: {
    flexDirection: 'row',
    borderWidth: 1,
    borderRadius: groupRadius,
    overflow: 'hidden',
    width: '100%'
  },
  bandTeam: {borderColor: bandTeamBorder, boxShadow: bandTeamGlow},
  bandCustomer: {borderColor: bandCustomerBorder},
  bandRail: {
    width: bandRailWidth,
    alignItems: 'center',
    justifyContent: 'center'
  },
  bandStacked: {flexDirection: 'column'},
  bandStrip: {
    width: '100%',
    minHeight: touchTargetMin,
    flexDirection: 'row',
    gap: 8,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 8
  },
  bandStripLabel: {...bandRailText, textAlign: 'center'},
  bandRailTeam: {backgroundColor: bandTeamRailBg},
  bandRailCustomer: {backgroundColor: bandCustomerRailBg},
  bandRailLabel: {
    ...bandRailText,
    position: 'absolute',
    left: '50%',
    top: '50%',
    width: 240,
    height: 18,
    marginLeft: -120,
    marginTop: -9,
    textAlign: 'center',
    transform: [{rotate: '-90deg'}]
  },
  bandRailLabelTeam: {color: teamAccent},
  bandRailLabelCustomer: {color: bandCustomerAccent},
  bandContent: {flex: 1, padding: 12},

  sectionHeader: {
    paddingVertical: 8,
    paddingHorizontal: 4
  },
  sectionHeaderTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10
  },
  sectionHeaderText: {flex: 1},
  sectionTitle: {
    fontFamily: 'Poppins_700Bold',
    fontSize: 22,
    letterSpacing: 0.3,
    color: textColor
  },
  sectionTitlePhone: {fontSize: mobileBandHeadSize},
  sectionDescription: {...groupHeaderDescText, marginTop: 2},
  sectionSubLabel: {...subLabelText, paddingVertical: 6},
  sectionChip: {
    borderWidth: 1,
    borderRadius: bandChipRadius,
    paddingHorizontal: 10,
    paddingVertical: 3
  },
  sectionChipTeam: {
    backgroundColor: bandTeamChipBg,
    borderColor: bandTeamChipBorder
  },
  sectionChipCustomer: {
    backgroundColor: bandCustomerChipBg,
    borderColor: bandCustomerBorder
  },
  sectionChipText: bandChipText,
  sectionChipTextTeam: {color: teamAccent},
  sectionChipTextCustomer: {color: bandCustomerAccent},

  groupCellFull: {width: '100%'},
  groupCard: {
    backgroundColor: groupBg,
    borderRadius: groupRadius,
    borderWidth: 1,
    borderColor: groupBorderColor,
    marginVertical: 6
  },
  groupCardOpenTeam: {borderColor: groupOpenBorderColor.team},
  groupCardOpenCustomer: {borderColor: groupOpenBorderColor.customer},
  groupCardDimmed: {opacity: groupDimmedOpacity},
  groupHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    paddingVertical: 12,
    paddingHorizontal: 12
  },
  groupHeaderPhone: {minHeight: touchRowMinHeight, flexWrap: 'wrap'},
  groupHeaderTextWrap: {flex: 1},
  groupHeaderTextWrapPhone: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '60%',
    minWidth: 120
  },
  groupTitle: groupHeaderText,
  groupDescription: groupHeaderDescText,
  groupBadge: {
    backgroundColor: groupCountPillBg,
    borderRadius: 10,
    paddingHorizontal: 8,
    paddingVertical: 2,
    flexShrink: 0
  },
  groupBadgeText: groupCountPillText,
  groupBody: {
    paddingHorizontal: 12,
    paddingBottom: 8,
    borderTopWidth: 1,
    borderTopColor: hairlineColor
  },

  rowGrid: {flexDirection: 'row', flexWrap: 'wrap'},
  rowCellFull: {width: '100%'},
  rowCellHalf: {width: '50%', paddingRight: 8},
  settingRow: {
    backgroundColor: rowBg,
    borderRadius: rowRadius,
    minHeight: rowMinHeight,
    justifyContent: 'center',
    paddingVertical: 8,
    paddingHorizontal: 10,
    marginVertical: 3
  },
  settingRowMatch: {
    borderWidth: 1,
    borderColor: matchRowBorderColor,
    backgroundColor: matchRowBg
  },
  settingRowPhone: {minHeight: touchRowMinHeight},
  settingRowLocked: {opacity: lockedRowOpacity},
  settingRowMain: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10
  },
  settingRowMainStacked: {
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    gap: 6
  },
  settingControlInline: {width: '45%', minWidth: 140},
  settingControlStacked: {width: '100%'},
  switchHit: {alignItems: 'center', justifyContent: 'center'},
  switchHitPhone: {minWidth: touchTargetMin, minHeight: touchTargetMin},
  settingLabelWrapStacked: {flexGrow: 0, flexBasis: 'auto'},
  settingLabelWrap: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    marginBottom: 2
  },
  settingLabel: rowLabelText,
  settingLabelLocked: {color: lockedRowText},
  settingLabelMatch: {
    backgroundColor: tooltipGradientColors[1],
    color: tooltipInkColor,
    borderRadius: 3
  },
  settingInfoButton: {padding: 2},
  settingInfoButtonPhone: {
    minWidth: touchTargetMin,
    minHeight: touchTargetMin,
    alignItems: 'center',
    justifyContent: 'center'
  },
  settingSavingText: groupHeaderDescText,
  settingTooltipBubble: {
    borderRadius: tooltipRadius,
    padding: 10,
    marginTop: 6,
    maxWidth: tooltipWidth
  },
  settingTooltipBubbleFull: {
    alignSelf: 'stretch',
    maxWidth: '100%',
    marginTop: 0,
    marginBottom: 6
  },
  settingTooltipText: tooltipText,
  settingInputNumber: {
    backgroundColor: numberInputBg,
    borderRadius: numberInputRadius,
    paddingHorizontal: 12,
    height: numberInputHeight,
    marginTop: 4,
    ...numberInputText
  },
  settingInputText: {
    backgroundColor: textInputBg,
    borderRadius: textInputRadius,
    paddingHorizontal: 12,
    height: textInputHeight,
    marginTop: 4,
    ...textInputText
  },
  settingInputPhone: {
    minHeight: touchButtonHeight,
    fontSize: mobileInputFontSize
  },
  selectTriggerPhone: {minHeight: touchButtonHeight},
  settingInputLockedText: {color: lockedRowText},
  settingInputInvalid: {borderColor: dangerColor, borderWidth: 1},
  settingInputLocked: {opacity: 0.5},
  groupErrorText: {
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 11,
    color: dangerColor
  },
  settingErrorText: {
    fontFamily: 'Poppins_500Medium',
    color: dangerColor,
    fontSize: 12,
    marginTop: 4
  },
  settingsSection: {width: '100%'}
});

export default styles;
